import {
  AuthField,
  AuthFoot,
  AuthGlassCard,
  AuthOr,
  MissionBrand,
  MissionPhotoStage,
  SocialButtons,
  StagingNote,
  useMissionAuth,
} from "@/components/mission-chrome";
import { useSkipLoginGate } from "@/components/auth-bypass-redirect";
import { Button } from "@/components/ui/button";
import { MISSION_HOME } from "@/lib/auth-callback";
import { Navigate } from "react-router-dom";

export function LoginPage() {
  const { skip, health, loaded, productionHost } = useSkipLoginGate();
  const auth = useMissionAuth(health);
  const emailEnabled = auth.emailOk || auth.cookieDemo;

  if (skip) return <Navigate to={MISSION_HOME} replace />;
  if (!loaded && !productionHost) {
    return (
      <div
        className="mission-surface relative h-full overflow-auto bg-black"
        role="status"
        aria-busy="true"
        aria-label="Loading"
      />
    );
  }

  return (
    <div className="mission-surface relative h-full overflow-auto bg-black">
      <MissionPhotoStage veil="auth" />
      <AuthGlassCard>
        <MissionBrand className="mb-1" />
        <p className="mb-3.5 text-[12px] tracking-[0.08em] text-white/50 uppercase">Team Platform</p>

        <SocialButtons
          health={health}
          busy={auth.busy}
          onGithub={() => void auth.signInSocial("github")}
          onGoogle={() => void auth.signInSocial("google")}
        />

        <AuthOr />

        <form
          key={loaded ? health.auth_mode ?? "unknown" : "pending"}
          className="flex flex-col gap-2.5"
          onSubmit={auth.onEmailForm("sign-in")}
        >
          <AuthField
            id="email"
            label="Email"
            type="email"
            placeholder="you@pcbx.ai"
            autoComplete="email"
            defaultValue={auth.cookieDemo ? "xz@pcbx.ai" : undefined}
            disabled={!emailEnabled || auth.busy}
          />
          <AuthField
            id="password"
            label="Password"
            type="password"
            placeholder="••••••••"
            autoComplete="current-password"
            defaultValue={auth.cookieDemo ? "demo-pass" : undefined}
            disabled={!emailEnabled || auth.busy}
          />
          <Button
            type="submit"
            variant="destructive"
            className="mt-0.5 h-10 w-full rounded-full text-[13px] font-semibold tracking-[0.06em] uppercase"
            disabled={!emailEnabled || auth.busy}
          >
            {auth.busy ? "Working…" : "Begin Mission"}
          </Button>
        </form>

        {auth.error ? <p className="mt-2.5 text-[12px] text-falcon">{auth.error}</p> : null}

        <AuthFoot to="/register" prompt="New here?" action="Create account" />
        <StagingNote health={health} loaded={loaded} />
      </AuthGlassCard>
    </div>
  );
}
